/**
 * Transforme le user_nicename (WordPress) en Code Producteur (API)
 * Ex: "billa" -> "BILLA"
 */
export const mapProducteurToApiCode = (userNicename) => {
  if (!userNicename) return null;
  return userNicename.toUpperCase().trim();
};

/**
 * Transforme le Titre du légume (WordPress) en Code Légume (API)
 * Ex: "Aubergine Graffiti" -> "AUBERGINE|GRAFFITI"
 */
export const mapLegumeToApiCode = (legumeTitle) => {
  if (!legumeTitle) return '';
  return legumeTitle.toUpperCase().trim().replace(/\s+/g, '|');
};
